const cohabitantsList = [
  'Padres',
  'Solo con madre',
  'Solo con padre',
  'Otro'
  /* Agregar mas familiares */
]

export default cohabitantsList
